import { useState } from 'react';
import { TextEditor } from '@/features/TextEditor';
import { TFormBuilderTextEditorField } from '@/types';

type TProps = {
  field: TFormBuilderTextEditorField;
};

/**
 * Preview component for text editor field in form builder
 * @param props - Component props
 * @param props.field - Text editor field data to preview
 * @returns Form builder text editor preview component
 */
export const FormBuilderPreviewTextEditor = ({ field }: TProps) => {
  const [value, setValue] = useState('');
  return (
    <TextEditor
      value={value}
      onChange={setValue}
      labelProps={{ label: field.label, required: field.required }}
      placeholder={field.placeholder}
    />
  );
};
